<form [formGroup]="form" class="mt-1">
  <ng-template #tipContent let-tooltipMsg="tooltipMsg">{{tooltipMsg}}</ng-template>
  <div class="formula-variable-container" *ngFor="let formulaVarName of getFormulaVariableNames(false)">
    <div class="formula-variable-content mt-1 mb-1" [ngClass]="{'dirty-entry': form.get(formulaVarName).dirty}" padding>

      <!-- Name input and buttons row -->
      <div class="name-and-buttons-row">
        <div class="input-group name-input-group">
          <span class="input-group-addon">Name</span>
          <input
            [value]="formulaVarName"
            id="{{formulaVarName}}"
            name="{{formulaVarName}}"
            [formControlName]='formulaVarName'
            [ngbTooltip]="tipContent" triggers="manual" #tt="ngbTooltip"
            (change)="onCheckForTooltip(tt, form.get(formulaVarName))"
            (keyup)="onCheckForTooltip(tt, form.get(formulaVarName))"
            (keydown)="onNameKeyDown($event, formulaInputEl, formulaVarName)"
            class="form-control"
            spellcheck="false"
            autocomplete="off"
            #formulaInputEl
          >
        </div>

        <div class="buttons-group">
          <button
            class="btn btn-success"
            [disabled]="(form.get(formulaVarName).errors || form.get(formulaVarName + 'Expression').errors || !form.dirty)  ? true : null"
            (click)="onEdit(formulaInputEl.value, formulaVarName)"
          >
            <i class="fa fa-save"></i>
          </button>
          <button class="btn btn-primary ml-1" (click)="onUndo(formulaVarName)">
            <i class="fa fa-undo"></i>
          </button>
          <button class="btn btn-danger ml-1" (click)="onRemove(formulaVarName)">
            <i class="fa fa-trash"></i>
          </button>
          <button
            class="btn btn-warning ml-1"
            [disabled]="!isFormulaFixable(formulaVarName)"
            title="{{_(KEYS.EDITOR.FORMULA_AUTOFIX)}}"
            (click)="onAutoFix(formulaVarName)"
          >
            <i class="fa fa-magic"></i>
          </button>
        </div>
      </div>

      <!-- Formula textarea row -->
      <div class="formula-textarea-row">
        <div class="formula-field-group" [ngClass]="{'has-formula-error': hasFormulaError(formulaVarName)}">
          <span class="formula-top-label">{{_(KEYS.EDITOR.FORMULA)}}</span>
          <div
            class="formula-editor-wrap"
            #wrapEl
            (mouseenter)="showFormulaTip(formulaVarName, wrapEl)"
            (mouseleave)="hideFormulaTip(formulaVarName, expressionEl)"
          >
            <div class="formula-highlight-backdrop" #backdropEl aria-hidden="true"><ng-container
              *ngFor="let seg of getExpressionSegments(formulaVarName)"><span
              [class.formula-error-token]="seg.isError">{{seg.text}}</span></ng-container>&nbsp;</div>
            <textarea
              [formControlName]='formulaVarName + "Expression"'
              (keyup)="showFormulaTip(formulaVarName, wrapEl)"
              (focus)="showFormulaTip(formulaVarName, wrapEl)"
              (blur)="closeFormulaTip(formulaVarName)"
              (scroll)="onExpressionScroll(backdropEl, $event.target, formulaVarName, wrapEl)"
              (keydown)="onExpressionKeyDown($event, formulaInputEl, formulaVarName)"
              class="form-control expression-textarea"
              rows="2"
              spellcheck="false"
              autocomplete="off"
              autocapitalize="off"
              #expressionEl
            ></textarea>
            <div
              class="formula-error-tip"
              *ngIf="tooltip && tooltip.varName === formulaVarName"
              [style.top.px]="tooltip.top"
              [style.left.px]="tooltip.left"
            >{{tooltip.message}}</div>
          </div>
        </div>
      </div>

      <!-- Error box for this formula -->
      <div class="alert alert-danger formula-error-box" *ngIf="hasFormulaError(formulaVarName)">
        <i class="fa fa-exclamation-triangle"></i> {{getFormulaErrorText(formulaVarName)}}
      </div>

    </div>
  </div>
</form>

<div class="input-group mt-2 mb-2">
  <span class="input-group-addon">{{_(KEYS.EDITOR.ADD_FORMULA_VARIABLE)}}</span>
  <button
    class="btn input-group-addon add-btn btn-success add-btn"
    (click)="onAdd()">
    <i class="fa fa-plus"></i>
  </button>
</div>
